/**
 * @implements {Partial<import('htmlparser2').Handler>}
 */
export default class ReplaceHandler {
    constructor(appendFn, regex, toComponent) {
        this._append = appendFn;
        this._regex = regex;
        this._toComponent = toComponent;
    }

    onopentag(tag, attrs) {
        this._append('<' + tag);

        for (const attr in attrs) {
            if (Object.prototype.hasOwnProperty.call(attrs, attr)) {
                this._append(` ${attr}="${attrs[attr]}"`);
            }
        }

        this._append('>');
    }

    onclosetag(tag) {
        this._append('</' + tag + '>');
    }

    ontext(text) {
        this._append(this.replace(text));
    }

    replace(str) {
        const out = str.replace(this._regex, this._toComponent);
        this._regex.lastIndex = 0;
        return out;
    }
}
